if (!customElements.get("accordion-image-section")) {
    customElements.define(
        "accordion-image-section",
        class AccordionImageSection extends HTMLElement {
            constructor() {
                super();

                // ✅ 基础元素与状态
                this.accordionImageItems = this.querySelectorAll(".accordion-image-item");
                this.mediaQuery = window.matchMedia("(min-width: 1001px)");
                this.handleClick = this.handleClick.bind(this);

                // ✅ 交互状态
                this.firstFlag = true;
                this.activeIndex = 0;
                this.isScrolling = false;
            }

            connectedCallback() {
                this.applyAccordionBehavior(this.mediaQuery.matches);

                // ✅ 监听窗口宽度变化
                this.mediaQuery.addEventListener("change", (e) => {
                    this.applyAccordionBehavior(e.matches);

                    if (e.matches) {
                        // 大于 1001px 激活滚动功能
                        this.PCPinScrollFunction(true);
                    } else {
                        // 小屏禁用 pc-pin-scroll
                        document.body.classList.remove("pc-pin-scroll");
                    }
                });

                // ✅ 初次加载（只在桌面端）
                if (this.mediaQuery.matches) {
                    this.PCPinScrollFunction(true);
                }
            }

            // ==============================
            // 鼠标 hover 激活切换
            // ==============================
            applyAccordionBehavior(isActive) {
                this.accordionImageItems.forEach((item) => {
                    item.removeEventListener("mouseenter", this.handleClick);
                    if (isActive) {
                        item.addEventListener("mouseenter", this.handleClick);
                    }
                });
            }

            // ==============================
            // IntersectionObserver 检测进入视口中部
            // ==============================
            PCPinScrollFunction(isActive) {
                if (!isActive) {
                    console.log("📱 当前为移动端，不启用 PCPinScrollFunction。");
                    return;
                }

                if (!this.firstFlag) {
                    console.log("🛑 firstFlag 为 false，PCPinScrollFunction 不再激活。");
                    return;
                }

                console.log("🧭 初始化 PCPinScrollFunction 监听……");

                const observer = new IntersectionObserver(
                    (entries) => {
                        entries.forEach((entry) => {
                            if (!this.firstFlag) return;

                            const ratio = entry.intersectionRatio;
                            if (entry.isIntersecting && ratio > 0.5) {
                                console.log("✅ 元素中部与视口中部相交，添加类名：pc-pin-scroll");
                                document.body.classList.add("pc-pin-scroll");
                            } else {
                                console.log("🚫 元素离开视口中部，移除类名：pc-pin-scroll");
                                document.body.classList.remove("pc-pin-scroll");
                            }
                        });
                    },
                    {
                        threshold: [0, 0.5, 1],
                        rootMargin: "0px 0px -50% 0px",
                    }
                );

                observer.observe(this);
                this.scrollMouse();
            }

            // ==============================
            // 鼠标滚轮切换内容
            // ==============================
            scrollMouse() {
                console.log("🖱️ 初始化 scrollMouse 滚轮监听...");

                // ✅ 初始化激活项
                this.activeIndex = Array.from(this.accordionImageItems).findIndex((item) =>
                    item.classList.contains("active")
                );
                if (this.activeIndex === -1) {
                    this.activeIndex = 0;
                    this.accordionImageItems[0].classList.add("active");
                }

                const handleScroll = (event) => {
                    // ✅ 只有在 pc-pin-scroll 模式下才触发
                    if (!document.body.classList.contains("pc-pin-scroll")) return;
                    if (this.isScrolling) return;
                    this.isScrolling = true;

                    const direction = event.deltaY > 0 ? "down" : "up";
                    console.log(`🌀 检测到滚动方向：${direction}`);

                    if (direction === "down") {
                        if (this.activeIndex < this.accordionImageItems.length - 1) {
                            this.activeIndex++;
                        } else {
                            console.log("🏁 已到最后一个元素，结束滚动模式。");
                            document.body.classList.remove("pc-pin-scroll");
                            this.firstFlag = false;
                            window.removeEventListener("wheel", handleScroll);
                            return;
                        }
                    } else {
                        if (this.activeIndex > 0) {
                            this.activeIndex--;
                        } else {
                            console.log("⚠️ 已到第一个元素，无法继续向上切换。");
                        }
                    }

                    // ✅ 切换激活状态
                    this.accordionImageItems.forEach((item, index) => {
                        item.classList.toggle("active", index === this.activeIndex);
                    });

                    console.log(`🎯 当前激活项索引：${this.activeIndex}`);

                    // ✅ 节流，避免滚动过快
                    setTimeout(() => {
                        this.isScrolling = false;
                    }, 600);
                };

                window.addEventListener("wheel", handleScroll, { passive: true });
            }

            // ==============================
            // 鼠标 hover 切换时同步 scroll 索引
            // ==============================
            handleClick(event) {
                const clickedItem = event.currentTarget;
                if (clickedItem.classList.contains("active")) return;

                this.accordionImageItems.forEach((item) => item.classList.remove("active"));
                clickedItem.classList.add("active");

                // ✅ 同步 scrollMouse 的全局索引
                this.activeIndex = Array.from(this.accordionImageItems).indexOf(clickedItem);
                console.log(`🖱️ 手动切换时同步索引：${this.activeIndex}`);
            }
        }
    );
}
